const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5001/api";

export async function submitContactEnquiry({ name, email, topic, message }) {
  let res;
  try {
    res = await fetch(`${API_BASE}/contact-enquiries`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        email,
        topic,
        message,
        source: "public-site",
      }),
    });
  } catch {
    throw new Error(
      "Cannot reach PagePeers right now. Please try again in a moment.",
    );
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Could not send your message");
  }
  return data;
}
